import { Helmet, HelmetProvider } from 'react-helmet-async';
import IncomingTenantsAdministration from "shared/components/rental/sections/incoming-tenants-administration";

const IncomingTenants = () => {
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Ingaande Huurders | Yally</title>
        </Helmet>
      </HelmetProvider>
      <IncomingTenantsAdministration />
    </>
  );
};

export default IncomingTenants;
